import React from 'react';
var ModalContext = React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onHide: function onHide() {}
});
export default ModalContext;